import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        dateField: {
            position: 'relative',
        },
        input: {
            '& input': {
                cursor: 'pointer',
            },
            '& .MuiInputBase-inputAdornedEnd': {
                textTransform: 'lowercase',
            },
        },
        requiredMark: {
            '&&': {
                position: 'absolute',
                left: -6,
                width: 4,
                height: 26,
                backgroundColor: theme.palette.primary.main,
                borderRadius: 3,
            },
        },
        isRequired: {
            '& .MuiInputBase-input': {
                backgroundColor: theme.palette.primary[30],
            },
        },
        errorMessage: {
            height: 10,
        },
    }
})

export default useStyles
